module.exports = __webpack_public_path__ + "static/media/Octocat.14f7c70e.png";